import React from 'react';

function Workflow() {
    const steps = [
        {
            number: "01",
            title: "Discovery",
            icon: "bi-search",
            description: "Deep-diving into your core objectives, brand identity, and user audience to architect a data-driven strategy."
        },
        {
            number: "02",
            title: "Design",
            icon: "bi-palette2",
            description: "Crafting high-fidelity visual concepts that balance aesthetic beauty with functional user experience."
        },
        {
            number: "03",
            title: "Development",
            icon: "bi-terminal-split",
            description: "Engineering robust, scalable codebases across mobile and web platforms with meticulous attention to detail."
        },
        {
            number: "04",
            title: "Launch",
            icon: "bi-rocket-takeoff-fill",
            description: "Rigorously testing and deploying high-performance systems designed for global scalability and impact."
        }
    ];

    return (
        <section id="workflow" className="py-32 bg-black relative overflow-hidden">
            {/* Background Glow */}
            <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-green-500/5 rounded-full blur-[100px] -translate-y-1/2 translate-x-1/2"></div>

            <div className="max-w-7xl mx-auto px-6 lg:px-12 relative z-10">

                <div className="flex flex-col items-center text-center mb-24 animate-fade-in-up">
                    <h2 className="text-green-500 font-black tracking-widest text-sm uppercase mb-4">The Process</h2>
                    <h3 className="text-6xl md:text-8xl font-black text-white leading-none uppercase tracking-tighter mb-8">Creative <br /><span className="text-transparent bg-clip-text bg-gradient-to-r from-gray-500 to-white">Pipeline.</span></h3>
                    <p className="max-w-2xl text-xl text-gray-400 font-medium">
                        A systematic, engineering-first approach to delivering digital excellence from concept to deployment.
                    </p>
                </div>

                <div className="relative">
                    {/* Connection Line (Desktop) */}
                    <div className="hidden lg:block absolute top-[120px] left-0 right-0 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent"></div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                        {steps.map((step, index) => (
                            <div key={index} className="relative group">
                                <div className="glass-card p-10 rounded-[3rem] h-full flex flex-col items-start hover:border-green-500/30 transition-all duration-700 hover:-translate-y-4">

                                    {/* Icon & Number Header */}
                                    <div className="flex justify-between items-start w-full mb-12">
                                        <div className="w-20 h-20 bg-green-500 text-black rounded-2xl flex items-center justify-center text-4xl shadow-[0_0_20px_rgba(71,232,2,0.3)] group-hover:rotate-12 transition-all duration-500">
                                            <i className={`bi ${step.icon}`}></i>
                                        </div>
                                        <span className="text-4xl font-black text-neutral-800 group-hover:text-green-500/10 transition-colors duration-500">
                                            {step.number}
                                        </span>
                                    </div>

                                    <div className="space-y-4">
                                        <h4 className="text-2xl font-black text-white uppercase tracking-tighter">
                                            {step.title}
                                        </h4>
                                        <p className="text-gray-400 text-lg leading-relaxed font-medium">
                                            {step.description}
                                        </p>
                                    </div>

                                    <div className="mt-10 pt-8 border-t border-white/5 w-full">
                                        <span className="text-[10px] font-black text-green-500 uppercase tracking-widest">
                                            Phase {step.number}
                                        </span>
                                    </div>
                                </div>

                                {/* Desktop Arrow */}
                                {index < steps.length - 1 && (
                                    <div className="hidden lg:flex absolute top-[120px] -right-4 translate-x-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-black border border-white/10 items-center justify-center text-green-500 z-20">
                                        <i className="bi bi-chevron-right text-xs"></i>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>

                <div className="mt-32 text-center">
                    <div className="inline-block p-1 bg-white/5 rounded-full border border-white/10 backdrop-blur-md">
                        <div className="px-8 py-4 flex items-center gap-4 text-gray-500 font-bold uppercase tracking-widest text-xs">
                            <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></span>
                            Refining Excellence Every Step of the Way
                        </div>
                    </div>
                </div>

            </div>
        </section>
    );
}

export default Workflow;